module.exports = __webpack_public_path__ + "img/TZS09450.a67228ce.jpeg";